import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';


const NewsFeedRow = ({ newsFeed, onClick }) => {
	const isClickable = !!onClick;

	const EventTitle = ({ title }) => (
		<Typography
			sx={{
				fontSize: '12px',
				color: 'text.primary',
				lineHeight: 1.45,
			}}
		>
			{title}
		</Typography>
	);

	const creationDatetime = newsFeed?.event_time
		? new Date(newsFeed.event_time).toLocaleString('en-US', {
				month: 'short',
				day: 'numeric',
				hour: 'numeric',
				minute: '2-digit',
			})
		: null;

	const EventCreation = ({ datetime }) => (
		<Typography
			sx={{
				fontSize: '11px',
				color: 'text.secondary',
			}}
		>
			{datetime}
		</Typography>
	);

	const EventSubtitle = ({ subtitle }) => (
		<Typography
			sx={{
				fontSize: '11px',
				color: 'text.secondary',
			}}
		>
			{subtitle}
		</Typography>
	);

	const Tag = ({ event_category }) => {
		const tagMap = {
			vdr: {
				label: '↔ VDR',
				tagColor: 'vdr',
			},
			signal: {
				label: 'Signal',
				tagColor: 'teal',
			},
			news: {
				label: 'News',
				tagColor: 'gray',
			},
			report: {
				label: 'Report',
				tagColor: 'green',
			},
		};

		return (
			<Box
				sx={{
					width: '50px',
					fontSize: '10px',
					fontWeight: 600,
					padding: '2px 6px',
					borderRadius: '3px',
					textAlign: 'center',
					backgroundColor:
						tagMap[event_category]?.tagColor === 'vdr'
							? 'vdr.bg'
							: `status.${tagMap[event_category]?.tagColor || 'gray'}.bg`,
					color:
						tagMap[event_category]?.tagColor === 'vdr'
							? 'vdr.text'
							: `status.${tagMap[event_category]?.tagColor || 'gray'}.text`,
					border:
						tagMap[event_category]?.tagColor === 'vdr' ? '0.5px solid' : 'none',
					borderColor:
						tagMap[event_category]?.tagColor === 'vdr'
							? 'vdr.border'
							: 'transparent',
					flexShrink: 0,
					mt: '2px',
					whiteSpace: 'nowrap',
				}}
			>
				{tagMap[event_category]?.label}
			</Box>
		);
	};

	return (
		<Box
			onClick={onClick}
			sx={{
				display: 'flex',
				alignItems: 'flex-start',
				gap: '9px',
				padding: '9px 15px',
				borderBottom: '0.5px solid',
				borderColor: 'border.light',
				'&:hover': {
					backgroundColor: 'background.subtle',
				},
				cursor: isClickable ? 'pointer' : 'default',
			}}
		>
			{newsFeed.event?.event_category && (
				<Tag event_category={newsFeed.event?.event_category}></Tag>
			)}
			{/* content */}
			<Box sx={{ flex: 1, minWidth: 0 }}>
				<Box sx={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
					{newsFeed.event?.event_title && (
						<EventTitle title={newsFeed.event.event_title} />
					)}
				</Box>

				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: '6px',
						mt: '2px',
					}}
				>
					{creationDatetime && <EventCreation datetime={creationDatetime} />}

					{creationDatetime && newsFeed.event?.event_subtitle ? ' · ' : ''}

					{newsFeed.event?.event_subtitle && (
						<EventSubtitle subtitle={newsFeed.event?.event_subtitle} />
					)}
				</Box>
			</Box>
		</Box>
	);
};

NewsFeedRow.propTypes = {
	newsFeed: PropTypes.object,
	onClick: PropTypes.func,
};

export default NewsFeedRow;
